// 接口
import axios from "@/axios";
import { baseUrl } from "@/axios/baseUrl";

// 获取设备类型
export const getbcmsblist = (data) =>
  axios.get(baseUrl + "/cm/device_type/list?" + data);
// 查看设备详情
export const getsbdatalist = (data) =>
  axios.get(baseUrl + "/cm/30min_new?" + data);
// 查看城市实时数据
export const getweatherdata = () => axios.get(baseUrl + "/city/real");
// 获取所有设备列表
export const getallsblist = (data) =>
  axios.get(baseUrl + "/cm/info/list?" + data);
// 获取设备统计
export const getsbcount = (data) =>
  axios.get(baseUrl + "/cm/home_count?" + data);
// 根据选中设备获取设备数据趋势
export const getdatacountbyids = (data) =>
  axios.post(
    baseUrl +
      "/api/data-center/data-trend/device-variable/history-data-by-device",
    data
  );
// 根据选中设备获取设备数据趋势
export const gethistorydata = (data) =>
  axios.post(
    baseUrl + "/api/data-center/monitoring-data/device-variable-data/page",
    data
  );
// 根据选中设备获取设备数据趋势
export const getwarlist = (data) =>
  axios.get(baseUrl + "/cm/cm_warn/page?" + data);
// 获取场景列表
export const getcjlist = (data) =>
  axios.get(baseUrl + "/cm/cm_warn/type?" + data);
// 获取场景列表
export const setreadstatus = (data) =>
  axios.put(baseUrl + "/cm/cm_warn/is_read/" + data);
// 获取场景列表
export const getonlinelist = () => axios.get(baseUrl + "/cm/device/online");
// AI任务-执行或忽略
export const aiTaskControl = (data) =>
  axios.put(baseUrl + "/cm/cm_warn/control?" + data);
// 获取设备分类列表
export const getdeviceclassifylist = (data) =>
  axios.post(
    baseUrl + "/api/data-center/data-trend/device-classify-list",
    data
  );
// 导出监控数据
export const exportMonitoringData = (data) =>
  axios.post(
    baseUrl + "/api/data-center/monitoring-data/export",
    data,
    {
      responseType: "blob",
    }
  );
